import React, { memo } from 'react'
import { Box } from '@mui/material'
import { Security } from '../../proto/generated/security'
import { OverviewWidgetResponse_FieldGroup } from '../../proto/generated/overview-widget'
import SecurityRange from './SecurityRange.tsx'
import SurveillanceIndicatorCard from './SurveillanceIndicatorCard'

export type OverviewPerformanceSectionProps = {
    security: Security
    /** Defaults to `security` when omitted (screener uses display row for surveillance). */
    surveillanceSecurity?: Security
    fieldGroups: OverviewWidgetResponse_FieldGroup[]
}

const OverviewPerformanceSection = ({
    security,
    surveillanceSecurity,
    fieldGroups
}: OverviewPerformanceSectionProps) => (
    <Box sx={{ px: 2, py: 1 }}>
        <SurveillanceIndicatorCard security={surveillanceSecurity ?? security} />
        <SecurityRange security={security} show52WkRange fieldGroups={fieldGroups} />
    </Box>
)

const overviewPerformanceSectionPropsAreEqual = (
    prev: OverviewPerformanceSectionProps,
    next: OverviewPerformanceSectionProps
) =>
    prev.fieldGroups === next.fieldGroups &&
    prev.security?.exchange === next.security?.exchange &&
    prev.security?.code === next.security?.code &&
    (prev.surveillanceSecurity?.exchange ?? prev.security?.exchange) ===
        (next.surveillanceSecurity?.exchange ?? next.security?.exchange) &&
    (prev.surveillanceSecurity?.code ?? prev.security?.code) ===
        (next.surveillanceSecurity?.code ?? next.security?.code)

export default memo(OverviewPerformanceSection, overviewPerformanceSectionPropsAreEqual)
